import axios from 'axios'
import {
    ConfigurationPersonnelDepartmentTypeAssignmentCreateRequest,
    ConfigurationPersonnelDepartmentTypeAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-department-type-assignment/configuration-personnel-department-type-assignment.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

class ConfigurationPersonnelDepartmentTypeAssignmentService {
    async create(laboratoryId: number, request: ConfigurationPersonnelDepartmentTypeAssignmentCreateRequest): Promise<ConfigurationPersonnelDepartmentTypeAssignmentResponse> {
        const response = await axios.post<ConfigurationPersonnelDepartmentTypeAssignmentResponse>(`/configuration/laboratories/${laboratoryId}/personnelDepartmentTypeAssignments`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationPersonnelDepartmentTypeAssignmentResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationPersonnelDepartmentTypeAssignmentResponse>>(`/configuration/laboratories/${laboratoryId}/personnelDepartmentTypeAssignments`, { ...filterModel }, { params })
        return response.data
    }

    async delete(personnelDepartmentTypeAssignmentId: number, laboratoryId: number): Promise<void> {
        const response = await axios.delete<void>(`/configuration/laboratories/${laboratoryId}/personnelDepartmentTypeAssignments/${personnelDepartmentTypeAssignmentId}`)
        return response.data
    }
}

export const configurationPersonnelDepartmentTypeAssignmentService = new ConfigurationPersonnelDepartmentTypeAssignmentService()
